import React, { useState, useEffect } from 'react';
// import { jsPDF } from "jspdf";
// import html2canvas from 'html2canvas';
import { submitAnswers, getPDF, getHTML } from '../../functions/api';
import ReactMarkdown from 'react-markdown';
import LoadingState from './LoadingState';
import ErrorState from './ErrorState';

import styles from './OutputPage.module.css';
import ForbiddenState from './ForbiddenState';

const OutputPage = ({ outro, answers, isEligable, isLoggedIn, availableUses, usageCount, hasStoredResults }) => {
  const [output, setOutput] = useState(null);
  const [outputState, setOutputState1] = useState('initial');
  const [message, setMessage] = useState(null);
  const [html, setHTML] = useState(null);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const setOutputState = (state) => {
    console.log(state);
    setOutputState1(state);
  }

  const retrySubmit = () => {
    setHasSubmitted(false);
  };

  useEffect(() => {
    if (!hasSubmitted && (outputState === 'initial' || outputState === 'error') && answers) {
      setHasSubmitted(true);
      console.log("Finalizing...");
      setOutputState('loading');
      submitAnswers(answers)
        .then(data => {
          console.log("Received results!")
          console.log(data);

          if (data.data && data.data.status) {
            if (data.data.status === 401) {
              console.log("Unauthorized");
              setOutputState('forbidden');
            }
            // 402: payment required -> redirect to payment
            else if (data.data.status === 402) {
              console.log("Payment required");
              setOutputState('forbidden');
            }
            else if (data.data.status === 403) {
              console.log("Forbidden");
              setOutputState('forbidden');
            }
          } else {
            setMessage(data.message);
            setOutput(data.result);
            setOutputState('ready');
          }
        })
        .catch(err => {
          // handle different error codes:
          if (err.response.status === 401 || err.response.status === 402 || err.response.status === 403) {
            setOutputState('forbidden');
          } else {
            console.log("Error: ", err);
            setOutputState('error');
          }
        });
    } else {
      console.log("Already finalized");
    }
  });

  const handlePDFDownload = async () => {
    try {
      const data = await getPDF();
      // DEBUG LOG
      // console.log(data)
      const blob = new Blob([data], { type: 'application/pdf' });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Datenschutzerklaerung.pdf';
      link.click();
    } catch (err) {
      console.error(err);
    }
  };

  const handleHTMLDownload = async () => {
    try {
      const data = await getHTML();
      if (data) setHTML(data);
      const blob = new Blob([data], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Datenschutzerklaerung.html';
      link.click();
    } catch (err) {
      console.error(err);
    }
  };

  const ReadyState = () => {
    return <>
      <h2 className={styles.outputPage_h}>Ergebnis</h2>
      <p className={styles.outputPage_p}>Hier direkt downloaden:</p>
      <div className={styles.buttonContainer}>
        <button onClick={handlePDFDownload}>Download PDF</button>
        <button onClick={handleHTMLDownload}>Download HTML</button>
      </div>
      <hr />
      <p className={styles.outputPage_p}>Du kannst die Ergebnisse jederzeit wieder abrufen!</p>
      <p className={styles.outputPage_p}>Solange du deine Antworten nicht änderst wird dir kein Nutzungsguthaben abgebucht.</p>
    </>;
  }

  return (
    <div className={styles.outputPage}>
      <h2 className={styles.outputPage_h}>Vielen Dank für die Nutzung des Datenschutzgenerators!</h2>
      {/* <ReactMarkdown skipHtml={true} className={styles.results}>{outro}</ReactMarkdown> */}
      <hr />
      {outputState === 'ready' ? <ReadyState /> : (
        outputState === 'loading' || outputState === 'initial' ? <LoadingState /> : (
          outputState === 'forbidden' ?
            (
              <div>
                <ForbiddenState isEligable={isEligable} isLoggedIn={isLoggedIn} availableUses={availableUses} usageCount={usageCount} />
                {hasStoredResults ? <ReadyState /> : null}
              </div>
            )
            :
            <ErrorState retrySubmit={retrySubmit} />
        )
      )}

      <hr />
      {/* <DebugDisplay answers={answers} /> */}
    </div>
  );
};

export default OutputPage;
